export const frequencyTypes = Object.freeze({
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  YEARLY: 'ANNUALLY',
  ONE_TIME: 'ONE_TIME',
  ONE_TIME_PAYMENT: 'ONE_TIME_PAYMENT',
});

// comment.
export const frequencyLabel = {
  DEFAULT: 'selectFrequency',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  YEARLY: 'yearly',
  ONE_TIME: 'oneTimeOnly',
  ONE_TIME_PAYMENT: 'oneTimePayment',
};

export const frequencyMappedToDisplay = {
  ANNUALLY: 'yearly',
  MONTHLY: 'monthly',
  WEEKLY: 'weekly',
  ONE_TIME: 'oneTimeOnly',
  ONE_TIME_PAYMENT: 'oneTimePaymentDisplay',
};

export type FrequencyType = $Values<typeof frequencyTypes>;
